import { Injectable } from "@angular/core";
import { AppSettings } from "../../proyect.conf";
import { HttpClient } from "@angular/common/http";
import { AutenticacionService } from "./autenticacion.service";
import { map } from "rxjs/operators";
import { ProductoFrecuenciaCuota } from '../_models/producto-frecuencia-cuota';
import {CuotasFrecuencia} from '../_models/cuotas-frecuencia';

@Injectable({
  providedIn: 'root'
})
export class ProductoFrecuenciaCuotaService {
  private rutServicio =
    AppSettings.rutServiciosAPL + "/api/productosFrecuenciasCuotas";

  constructor(
    private httClient: HttpClient,
    private autServicio: AutenticacionService
  ) {}

  listado() {
    return this.httClient
      .get(this.rutServicio)
      .pipe(map((res) => res as ProductoFrecuenciaCuota[]));
  }

  listadoHabilitados() {
    return this.httClient
      .get(this.rutServicio + "/enabled")
      .pipe(map((res) => res as ProductoFrecuenciaCuota[]));
  }

  listadoProductoFrecuencia(idProductoFrecuencia: string) {
    return this.httClient
      .get(this.rutServicio + "/productoFrecuencia/" + idProductoFrecuencia)
      .pipe(map((res) => res as ProductoFrecuenciaCuota[]));
  }

  listadoProductoFrecuenciaHabilitados(idProductoFrecuencia: string) {
    return this.httClient
      .get(this.rutServicio + "/productoFrecuencia/" + idProductoFrecuencia + '/enabled')
      .pipe(map((res) => res as ProductoFrecuenciaCuota[]));
  }

  listadoProductoHabilitados(idProductoFrecuencia: string) {
    return this.httClient
      .get(this.rutServicio + "/producto/" + idProductoFrecuencia + '/enabled')
      .pipe(map((res) => res as ProductoFrecuenciaCuota[]));
  }

  obtenerPorId(id: string) {
    return this.httClient
      .get(this.rutServicio + "/" + id)
      .pipe(map((res) => res as ProductoFrecuenciaCuota));
  }

  crear(regCrear: ProductoFrecuenciaCuota) {
    regCrear.auditoriaUsuario = this.autServicio.obtenerIdUsuarioLogueado();
    return this.httClient
      .post(this.rutServicio, regCrear)
      .pipe(map((res) => res as ProductoFrecuenciaCuota));
  }

  actualizar(regActualizar: ProductoFrecuenciaCuota) {
    regActualizar.auditoriaUsuario = this.autServicio.obtenerIdUsuarioLogueado();
    return this.httClient
      .put(this.rutServicio, regActualizar)
      .pipe(map((res) => res as any));
  }
  listadoCuotas(idProductoFrecuencia: string) {
    return this.httClient.get(`${this.rutServicio}/listaGenerica/${idProductoFrecuencia}/enabled`).pipe(map( resp => resp as CuotasFrecuencia[]))
  }
}
